<label>
  <div
    class="form-field__label form-field__text-label"
    [class.form-field__label--error]="showError"
  >
    {{ field.label ?? '' | translateInline }}
  </div>
  @if (_displayValueTransformer) {
    <input
      [(ngModel)]="value"
      [fmntsValueTransform]="_displayValueTransformer"
      class="form-field__input form-field__text-input"
      [class.form-field__input--error]="showError"
      [class.form-field__text-input--readonly]="this.isReadonly"
      [disabled]="this.isReadonly"
      [type]="inputType"
      [attr.inputmode]="inputMode"
      (blur)="_onTouched(); this.trim()"
      [attr.autocapitalize]="autocapitalize"
      [attr.autocomplete]="autocomplete()"
    />
  } @else {
    <input
      [(ngModel)]="value"
      class="form-field__input form-field__text-input"
      [class.form-field__input--error]="showError"
      [type]="inputType"
      [attr.inputmode]="inputMode"
      (blur)="_onTouched(); this.trim()"
      [class.form-field__text-input--readonly]="this.isReadonly"
      [disabled]="this.isReadonly"
      [attr.autocapitalize]="autocapitalize"
      [attr.autocomplete]="autocomplete()"
    />
  }

  <div class="form-field__error-message">
    @if (showError && control.errors) {
      <div>
        {{ control.errors | declarativeErrorMessage: field : declaration }}
      </div>
    }
  </div>
</label>
